/**
 * Клас для копіювання тексту в буфер обміну.
 * Зчитує дані з атрибута та додає візуальний фідбек.
 */
export default class ClipboardCopy {
    /**
     * @param {string} selector - CSS селектор елементів, що тригерять копіювання.
     * @param {Object} options - Налаштування.
     * @param {string} options.successClass - Клас успішного копіювання (за замовчуванням '_copied').
     * @param {number} options.delay - Час (в мс), через який зникає стан успіху (за замовчуванням 2000).
     */
    constructor(selector, options = {}) {
        this.buttons = options.buttons || document.querySelectorAll("[data-copy]");
        this.successClass = options.successClass || "_copied";
        this.delay = options.delay || 2000;

        if (!this.buttons.length) return;

        this.init();
    }

    /**
     * Ініціалізація подій кліку та натискання клавіш.
     */
    init() {
        this.buttons.forEach((button) => {
            button.addEventListener("click", (e) => this.handleCopy(e.currentTarget));

            // Підтримка клавіатури, оскільки елемент має role="button" та tabindex="0"
            button.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.handleCopy(e.currentTarget);
                }
            });
        });
    }

    /**
     * Метод обробки копіювання.
     * @param {HTMLElement} triggerElement - Елемент, з якого береться текст.
     */
    async handleCopy(triggerElement) {
        const textToCopy = triggerElement.getAttribute("data-copy");

        if (!textToCopy) {
            console.warn("ClipboardCopy: Відсутній атрибут data-copy або він порожній.");
            return;
        }

        try {
            // Clipboard API
            await navigator.clipboard.writeText(textToCopy);
            this.showSuccess(triggerElement);
        } catch (err) {
            console.error("ClipboardCopy: Помилка копіювання тексту", err);
        }
    }

    /**
     * Візуальне відображення успішного копіювання.
     * @param {HTMLElement} element - Елемент, якому додається клас успіху.
     */
    showSuccess(element) {
        // Очищуємо попередні таймери, якщо користувач клікнув кілька разів підряд
        if (element.copyTimeout) {
            clearTimeout(element.copyTimeout);
        }

        element.classList.add(this.successClass);

        element.copyTimeout = setTimeout(() => {
            element.classList.remove(this.successClass);
        }, this.delay);
    }
}
